'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _configRun = require('./config/run');

var _configRun2 = _interopRequireDefault(_configRun);

var _configRoute = require('./config/route');

var _configRoute2 = _interopRequireDefault(_configRoute);

var _configAnimate = require('./config/animate');

var _configAnimate2 = _interopRequireDefault(_configAnimate);

var _configException = require('./config/exception');

var _configException2 = _interopRequireDefault(_configException);

var _filtersNospace = require('./filters/nospace');

var _filtersNospace2 = _interopRequireDefault(_filtersNospace);

var _modulesAppCore = require('./modules/app.core');

var _modulesAppCore2 = _interopRequireDefault(_modulesAppCore);

var _modulesAppDefinitions = require('./modules/app.definitions');

var _modulesAppDefinitions2 = _interopRequireDefault(_modulesAppDefinitions);

var _modulesAppServices = require('./modules/app.services');

var _modulesAppServices2 = _interopRequireDefault(_modulesAppServices);

var _modulesAppControllers = require('./modules/app.controllers');

var _modulesAppControllers2 = _interopRequireDefault(_modulesAppControllers);

var _modulesAppDirectives = require('./modules/app.directives');

var _modulesAppDirectives2 = _interopRequireDefault(_modulesAppDirectives);

var _modulesAppFactories = require('./modules/app.factories');

var _modulesAppFactories2 = _interopRequireDefault(_modulesAppFactories);

var appMain = 'app';

exports['default'] = _angular2['default'].module(appMain, [
/**
 * Definitions init, consts, version.
 */
appMain + '.definitions',

/**
 * Core componenets init
 */
appMain + '.core',

/**
 * Services componenets init
 */
appMain + '.services',

/**
 * Controllers componenets init
 */
appMain + '.controllers',

/**
 * Directives componenets init
 */
appMain + '.directives',

/**
 * Factories componenets init
 */
appMain + '.factories'])

// Config elements
.config(_configException2['default']).config(_configAnimate2['default']).config(_configRoute2['default'])

// filters
.filter('nospace', _filtersNospace2['default'])

// RUNN!
.run(_configRun2['default']);
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./resources/assets/js/src/bootstrap.js
 ** module id = 1
 ** module chunks = 0
 **/